/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { Text, Theme, useTheme } from 'bold-ui'
import { useAtendimentoContext } from 'hooks/atendimento-context/useAtendimentoContext'
import { formatDate } from 'util/date/formatDate'
import { humanizeAge } from 'util/date/humanize-age'
import { isObjectDeepEmpty } from 'util/object'
import { formatNomeProfissional } from 'view/profissional/utils/utils-profissional'

import { MChatAnteriorFooterInfoModel } from '../model-mchat'

interface MChatFooterInfoProps {
  mChat: MChatAnteriorFooterInfoModel
}

export function MChatFooterInfo(props: MChatFooterInfoProps) {
  const { mChat } = props

  const theme = useTheme()
  const styles = createStyles(theme)
  const {
    cidadao: { dataNascimento },
  } = useAtendimentoContext()

  if (isObjectDeepEmpty(mChat)) return null

  const {
    lotacao: { profissional, cbo },
    dataResultado,
  } = mChat

  const humanizedAge = humanizeAge(dataNascimento, dataResultado)
  const avaliadoPorText = `${formatNomeProfissional(profissional)} - ${cbo.nome.titleCase()} em ${formatDate(
    dataResultado
  )}`

  return (
    <Text style={styles.text}>
      <strong>Avaliado por: </strong>
      {avaliadoPorText}
      {' | '}
      <strong>Idade da criança na avaliação: </strong>
      {humanizedAge}
    </Text>
  )
}

const createStyles = (theme: Theme) => ({
  text: css`
    color: ${theme.pallete.gray.c20};
  `,
})
